import { TechnologyFilter } from "../../components/filters/TechnologyFilter/TechnologyFilter";
import { TechnologyFilterResult } from "../../components/filters/TechnologyFilter/TechnologyFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineTechnologiesFilter } from "../defineSourcedFilter";

import FindTechnologyFilter from "./TechnologyFilter";

export const technologiesDefinition = defineTechnologiesFilter({
    key: "technologies",
    apiCategory: leadsFilterApiCategory.technologies,
    category: leadsFilterCategoryMap.website,
    trackingName: "technologies",
    titleKey: { key: "si.lead_gen_filters.group.technologies.name" },

    render: ({ technologies }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.technologies.tooltip" },
        filter: new FindTechnologyFilter({
            options: technologies,
        }),
        filterView: TechnologyFilter,
        filterResultView: TechnologyFilterResult,
    }),
});
